// Gedeelde bouwstenen van de Productie Breakdown-tabbladen (één stijl voor alle tabs).
import React from 'react';
import { Box, Button, ButtonBase, Typography } from '@mui/material';
import { ACCENT, INKT, LIJN, STATUSSEN, STIL } from './breakdownApi';

export function Kaart({ children, sx }) {
  return <Box sx={{ border: `1px solid ${LIJN}`, borderRadius: 2, bgcolor: '#fff', overflow: 'hidden', ...sx }}>{children}</Box>;
}

export function Rij({ children, sx }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 1.5, py: 1, borderTop: `1px solid ${LIJN}`,
      '&:first-of-type': { borderTop: 0 }, '&:hover': { bgcolor: '#fafbfc' }, ...sx }}>
      {children}
    </Box>
  );
}

export function Kop({ children, rechts, sx }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.75, ...sx }}>
      <Typography sx={{ flex: 1, fontSize: 14, fontWeight: 700, color: INKT }}>{children}</Typography>
      {rechts}
    </Box>
  );
}

export function Leeg({ children }) {
  return (
    <Box sx={{ border: `1px dashed ${LIJN}`, borderRadius: 2, p: 3, textAlign: 'center' }}>
      <Typography sx={{ fontSize: 13.5, color: STIL }}>{children}</Typography>
    </Box>
  );
}

export function Uitleg({ children }) {
  return <Typography sx={{ fontSize: 13, color: STIL, mb: 2 }}>{children}</Typography>;
}

export function Primair({ children, ...props }) {
  return (
    <Button variant="contained" disableElevation size="small" {...props}
      sx={{ textTransform: 'none', fontWeight: 600, bgcolor: ACCENT, '&:hover': { bgcolor: '#434f62' }, ...props.sx }}>
      {children}
    </Button>
  );
}

export function Secundair({ children, ...props }) {
  return (
    <Button variant="outlined" size="small" {...props}
      sx={{ textTransform: 'none', color: ACCENT, borderColor: LIJN, ...props.sx }}>
      {children}
    </Button>
  );
}

export function Stil({ children, ...props }) {
  return <Button size="small" {...props} sx={{ textTransform: 'none', color: STIL, ...props.sx }}>{children}</Button>;
}

export function StatusChip({ status, onClick }) {
  const s = STATUSSEN[status] || STATUSSEN.open;
  return (
    <ButtonBase onClick={onClick} disabled={!onClick} title={onClick ? 'Klik voor de volgende status' : undefined}
      aria-label={`Status: ${s.label}${onClick ? ' — klik voor de volgende' : ''}`}
      sx={{ px: 1, py: 0.3, borderRadius: 10, fontSize: 12, fontWeight: 600, color: s.kleur, bgcolor: s.bg, whiteSpace: 'nowrap', flexShrink: 0 }}>
      {s.label}
    </ButtonBase>
  );
}

export function Label({ children, kleur = STIL, bg = '#f1f3f6' }) {
  return (
    <Box component="span" sx={{ px: 0.9, py: 0.2, borderRadius: 10, fontSize: 11.5, fontWeight: 600, color: kleur, bgcolor: bg, whiteSpace: 'nowrap' }}>
      {children}
    </Box>
  );
}
